// UID: BWR-TAX_RTN-CHK
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2347
import { isYes } from '../../../../../../../components/loan_application/utils/helpers';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { taxDocuments } from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { applicantFiledTaxReturnsInThePast } = taxDocuments;

class HasApplicantFiledTR implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const hasFiled = application[applicantFiledTaxReturnsInThePast.name];
    return hasFiled !== null && hasFiled !== undefined && isYes(hasFiled);
  }
}

export default new HasApplicantFiledTR();
